import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { 
  AUTH_USER, 
  SOCKET_CONNECT, 
  SOCKET_DISCONNECT, 
  UNAUTH_USER, 
  AUTH_ERROR, 
  FILL_SIGNIN_EMAIL, 
  SET_CURRENT_USER, 
  SET_INTERVAL_ID,
  NOTI_TIMEOUT,
  BASE_URL 
} from './types';
import { getTickerInfo } from './index';

export function signinUser({ email, password, history }) {
  const request = axios.post(`${BASE_URL()}/api/signin`, { email, password });
  return (dispatch, getState) => {
    request.then(response => {
      const { token, email } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('currentUser', email);
      dispatch(setUp({ email }));
      history.push('/dashboard');
    }).catch((err) => {
      dispatch(authError('Incorrect Login Info'));
    });
  }
}

export function signoutUser() {
  localStorage.removeItem('token');  
  localStorage.removeItem('currentUser');
  return (dispatch, getState) => {
    clearInterval(getState().session.intervalId);
    dispatch({ type: SOCKET_DISCONNECT });
    dispatch({ type: UNAUTH_USER });
    dispatch(setIntervalId(null));
  }
}

export function signUpUser({ email, password, code, history }) {
  const request = axios.post(`${BASE_URL()}/api/signup`, { email, password, code });
  return (dispatch) => { 
    request.then(response => { 
      dispatch(fillSignInEmail(email));
      history.push('/signin');
      NotificationManager.success(`You have succesfully created your new account: ${email}`, 'Account Created!', NOTI_TIMEOUT);        
    }).catch((error) => {
      dispatch(authError(error.response.data.error));
    });
  }
}

export function setUp({ email }) {
  return (dispatch, getState) => {
    dispatch({ type: AUTH_USER });
    dispatch(setCurrentUser(email));
    dispatch(getTickerInfo()).then(() => {
      dispatch({ type: SOCKET_CONNECT, payload: getState().user.tickers }); 
    });
    if (!getState().session.intervalId) {
      const intervalId = setInterval(() => {
        console.log('Retrieved.');
        dispatch(getTickerInfo());  
      }, 30000);
      dispatch(setIntervalId(intervalId));
    } 
  };
}

export function fillSignInEmail(payload) {
  return {
    type: FILL_SIGNIN_EMAIL,
    payload: payload
  };
}

export function authError(error) {
  return {
    type: AUTH_ERROR,
    payload: error
  };
}

function setCurrentUser(payload) {
  return {
    type: SET_CURRENT_USER,
    payload: payload
  };
}

function setIntervalId(id) {
  return {
    type: SET_INTERVAL_ID,
    payload: id
  };
}